import script from "./TripView.vue?vue&type=script&setup=true&lang=js"
export * from "./TripView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__